import React, { useMemo } from "react";
import Hero from "../../components/Hero/Hero";
import Welcome from "../../components/Welcome/Welcome";
import Highlights from "../../components/Highlights/Highlights";
import ServicePreview from "../../components/ServicePreview/ServicePreview";
import TestimonialPreview from "../../components/TestimonialPreview/TestimonialPreview";
import ContactPreview from "../../components/ContactPreview/ContactPreview";
import EducationPreview from "../../components/EducationPreview/EducationPreview";
import useFirebaseContent from "../../utils/useFirebaseContent";
import { homePageContent } from "../../constants/homePageContent";
import "./HomePage.css";

const HomePage = () => {
  // Define default structure using the shared constants
  const defaultPageContent = useMemo(
    () => ({
      hero: homePageContent.content.hero,
      welcome: homePageContent.content.welcome,
      highlights: homePageContent.content.highlights,
      servicePreview: homePageContent.content.servicePreview,
      testimonials: homePageContent.content.testimonials,
      contact: homePageContent.content.contact,
      education: homePageContent.content.education,
    }),
    []
  );

  // Fetch home page content from Firebase with structured default and default title
  const { content } = useFirebaseContent(
    "home",
    defaultPageContent,
    homePageContent.title
  );

  // Pass content to child components as props
  return (
    <div className="home">
      <Hero content={content.hero} />
      <Welcome content={content.welcome} />
      <Highlights content={content.highlights} />
      <ServicePreview content={content.servicePreview} />
      <TestimonialPreview content={content.testimonials} />
      <ContactPreview content={content.contact} />
      <EducationPreview content={content.education} />
    </div>
  );
};

export default HomePage;
